exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".add-tube-btn{background-image:linear-gradient(#b00, #f00, #b00);border-radius:15px;color:snow;font-size:3rem;height:40px;margin:10px;padding:0 0 70px;text-align:center;transition:transform .2s;width:72px}.add-tube-btn:hover{color:#eee9e9;transform:scale(1.1)}.m0{margin:0}.table-head{font-weight:bold}.videos-header{align-items:center;display:flex;justify-content:space-between}.videos-header-text{font-weight:bold}.videos-table{display:flex;justify-content:space-around}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/videos/components/Videos/Videos.scss
// module id = 364
// module chunks = 0